/* WyldCam X — motion and interactions (round 12). No dependencies. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------- Split headings on <br> into masked lines ---------- */
  function split(el) {
    if (el.dataset.xSplitDone) return;
    var parts = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = parts.map(function (p, i) {
      return '<span class="x-split-line" style="--l:' + i + '"><span>' + p.trim() + '</span></span>';
    }).join('');
    el.dataset.xSplitDone = '1';
  }

  /* ---------- Reveal on scroll ---------- */
  function reveal(root) {
    $$('.x-split', root).forEach(split);
    var els = $$('.x-rv, .x-rv-mask, .x-split, [data-x-meter]', root);
    if (!('IntersectionObserver' in w) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); fillMeter(e); }); return; }
    /* Clipped elements cannot be observed directly (their own clip-path hides them), so watch the parent */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var list = en.target.__xTargets || [en.target];
        list.forEach(function (t) { t.classList.add('is-in'); fillMeter(t); });
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (e) {
      var watch = e.classList.contains('x-rv-mask') ? e.parentElement : e;
      if (watch !== e) { (watch.__xTargets = watch.__xTargets || []).push(e); }
      io.observe(watch);
    });
  }
  function fillMeter(e) {
    if (!e.hasAttribute('data-x-meter')) return;
    var n = parseInt(e.getAttribute('data-x-meter'), 10) || 0;
    $$('i', e).forEach(function (i, k) { if (k < n) i.classList.add('is-on'); });
  }

  /* ---------- Hero HUD: live UK clock + roaming focus box ---------- */
  function hero(root) {
    $$('[data-x-clock]', root).forEach(function (el) {
      var fmt;
      try { fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }); } catch (e) { fmt = null; }
      var dfmt;
      try { dfmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { dfmt = null; }
      var tick = function () {
        var now = new Date();
        el.textContent = (dfmt ? dfmt.format(now) : now.toLocaleDateString()) + '  ' + (fmt ? fmt.format(now) : now.toLocaleTimeString());
      };
      tick(); setInterval(tick, 1000);
    });
    $$('[data-x-focus]', root).forEach(function (box) {
      if (reduce) return;
      var spots;
      try { spots = JSON.parse(box.getAttribute('data-x-focus')); } catch (e) { spots = []; }
      if (!spots.length) return;
      var i = 0;
      setInterval(function () {
        i = (i + 1) % spots.length;
        box.classList.remove('is-locked');
        box.style.setProperty('--fx', spots[i][0] + '%');
        box.style.setProperty('--fy', spots[i][1] + '%');
        setTimeout(function () { box.classList.add('is-locked'); }, 650);
      }, 3200);
    });
  }

  /* ---------- Rail: filter chips, progress, arrows ---------- */
  function rail(root) {
    $$('[data-x-rail]', root).forEach(function (sec) {
      var track = $('.x-rail__track', sec), bar = $('.x-progress i', sec);
      var prev = $('[data-x-prev]', sec), next = $('[data-x-next]', sec);
      if (!track) return;
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth;
        var vis = track.clientWidth / Math.max(track.scrollWidth, 1);
        if (bar) { bar.style.width = (vis * 100).toFixed(2) + '%'; bar.style.marginLeft = (max > 0 ? (track.scrollLeft / max) * (100 - vis * 100) : 0).toFixed(2) + '%'; }
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
      };
      var step = function (dir) {
        var card = $('.x-card:not([hidden])', track);
        var by = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * by, behavior: reduce ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', upd, { passive: true });
      w.addEventListener('resize', upd);
      $$('.x-filter', sec).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-filter');
          $$('.x-filter', sec).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          $$('.x-card', track).forEach(function (c) { c.hidden = !(f === 'all' || (c.getAttribute('data-family') || '') === f); });
          track.scrollTo({ left: 0 }); upd();
        });
      });
      upd();
    });
  }

  /* ---------- Spotlight: 3D tilt + hotspots ---------- */
  function spot(root) {
    $$('[data-x-tilt]', root).forEach(function (stage) {
      var card = $('.x-spot__card', stage);
      var amp = parseFloat(stage.getAttribute('data-x-tilt')) || 1;
      if (!card || reduce) return;
      var raf = 0, tx = 0, ty = 0, cx = 0, cy = 0;
      var loop = function () {
        cx = lerp(cx, tx, 0.12); cy = lerp(cy, ty, 0.12);
        card.style.setProperty('--ry', (cx * 14 * amp).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (-cy * 12 * amp).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (50 + cx * 40).toFixed(1) + '%');
        card.style.setProperty('--gy', (40 + cy * 40).toFixed(1) + '%');
        if (Math.abs(cx - tx) > 0.001 || Math.abs(cy - ty) > 0.001) raf = requestAnimationFrame(loop); else raf = 0;
      };
      var kick = function () { if (!raf) raf = requestAnimationFrame(loop); };
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        tx = clamp((e.clientX - r.left) / r.width * 2 - 1, -1, 1);
        ty = clamp((e.clientY - r.top) / r.height * 2 - 1, -1, 1);
        kick();
      });
      stage.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
      /* Touch: tilt follows scroll position */
      if (w.matchMedia('(hover: none)').matches) {
        w.addEventListener('scroll', function () {
          var r = stage.getBoundingClientRect();
          var p = clamp((r.top + r.height / 2) / w.innerHeight, 0, 1);
          tx = (p - 0.5) * 1.2; ty = (0.5 - p) * 0.6; kick();
        }, { passive: true });
      }
    });
    $$('.x-spot__dot button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var dot = b.parentNode, open = !dot.classList.contains('is-open');
        $$('.x-spot__dot', dot.parentNode).forEach(function (x) { x.classList.remove('is-open'); });
        if (open) dot.classList.add('is-open');
      });
    });
  }

  /* ---------- Dusk to dawn: sticky scroll ---------- */
  var SKY = [
    [0.00, '#5B6B80', '#E2A46B'], [0.18, '#2F3A55', '#B5654A'], [0.38, '#141B2C', '#3A3550'],
    [0.62, '#0B0F17', '#151C26'], [0.84, '#172033', '#3D4A63'], [1.00, '#5E7391', '#E8B98A']
  ];
  function hexToRgb(h) { var n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function mix(a, b, t) { var x = hexToRgb(a), y = hexToRgb(b); return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(lerp(x[i], y[i], t)); }).join(',') + ')'; }
  function skyAt(p) {
    for (var i = 0; i < SKY.length - 1; i++) {
      var a = SKY[i], b = SKY[i + 1];
      if (p >= a[0] && p <= b[0]) { var t = (p - a[0]) / (b[0] - a[0]); return [mix(a[1], b[1], t), mix(a[2], b[2], t)]; }
    }
    return [SKY[SKY.length - 1][1], SKY[SKY.length - 1][2]];
  }
  function dusk(root) {
    $$('[data-x-dusk]', root).forEach(function (sec) {
      var pin = $('.x-dusk__pin', sec), clock = $('[data-x-dclock]', sec), items = $$('.x-dusk__list li', sec);
      var imgs = $$('.x-dusk__img', sec), bar = $('.x-dusk__bar i', sec), sky = $('.x-dusk__sky', sec);
      var start = parseFloat(sec.getAttribute('data-start') || '17'), span = parseFloat(sec.getAttribute('data-span') || '13');
      var ticking = false;
      var paint = function () {
        ticking = false;
        var r = sec.getBoundingClientRect();
        var pt = parseFloat(getComputedStyle(pin).top) || 0;
        var total = Math.max(sec.offsetHeight - pin.offsetHeight, 1);
        var p = reduce ? 0.5 : clamp((pt - r.top) / total, 0, 1);
        var hours = start + p * span; var hh = Math.floor(hours) % 24; var mm = Math.floor((hours % 1) * 60);
        if (clock) clock.textContent = (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm;
        var s = skyAt(p); if (sky) { sky.style.setProperty('--sky-a', s[0]); sky.style.setProperty('--sky-b', s[1]); }
        if (bar) bar.parentNode.style.setProperty('--p', p.toFixed(3));
        if (imgs.length) {
          var seg = 1 / imgs.length;
          imgs.forEach(function (im, k) {
            var c = (k + 0.5) * seg, dist = Math.abs(p - c);
            im.style.setProperty('--o', clamp(1 - (dist - seg * 0.35) / (seg * 0.5), 0, 0.9).toFixed(3));
          });
        }
        items.forEach(function (li) {
          var t = parseFloat(li.getAttribute('data-h')); var tt = t < start ? t + 24 : t;
          li.classList.toggle('is-on', hours >= tt - 0.25);
        });
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } };
      w.addEventListener('scroll', onScroll, { passive: true });
      w.addEventListener('resize', onScroll);
      paint();
    });
  }

  /* ---------- Parallax bands ---------- */
  function parallax(root) {
    if (reduce) return;
    var els = $$('[data-x-parallax]', root);
    if (!els.length) return;
    var t = false;
    var run = function () {
      t = false;
      els.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        var p = (r.top + r.height / 2 - w.innerHeight / 2) / w.innerHeight;
        el.style.setProperty('--py', (-p * 60).toFixed(1) + 'px');
      });
    };
    w.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Camera finder ---------- */
  function finder() {
    var modal = $('[data-x-finder]');
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = '1';
    var data; try { data = JSON.parse($('[data-x-finder-data]', modal).textContent); } catch (e) { data = []; }
    var qs = $$('.x-finder__q', modal), res = $('.x-finder__res', modal), steps = $$('.x-finder__steps i', modal);
    var answers = {}, cur = 0, lastFocus = null;
    var show = function (i) {
      cur = i;
      qs.forEach(function (q, k) { q.classList.toggle('is-on', k === i); });
      res.classList.toggle('is-on', i === qs.length);
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k <= i); });
    };
    var open = function () { lastFocus = d.activeElement; modal.classList.add('is-open'); modal.removeAttribute('aria-hidden'); d.documentElement.style.overflow = 'hidden'; show(0); var f = $('.x-opt', modal); if (f) f.focus(); };
    var close = function () { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); d.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); };
    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-x-finder-open]');
      if (o) { e.preventDefault(); open(); return; }
      if (e.target === modal || e.target.closest('[data-x-finder-close]')) close();
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    $$('.x-opt', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.closest('.x-finder__q'); var key = q.getAttribute('data-key');
        $$('.x-opt', q).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        answers[key] = b.getAttribute('data-v');
        setTimeout(function () { if (cur + 1 >= qs.length) { render(); } show(cur + 1); }, 220);
      });
    });
    $$('[data-x-finder-back]', modal).forEach(function (b) { b.addEventListener('click', function () { show(Math.max(cur - 1, 0)); }); });

    function score(p) {
      var s = 0, why = [];
      var fam = p.family;
      /* Where should the photos go? */
      if (answers.photos === 'card') { s += fam === 'sd' ? 40 : (fam === 'wifi' ? 12 : 0); if (fam === 'sd') why.push('saves to an SD card, no app needed'); }
      if (answers.photos === 'near') { s += fam === 'wifi' ? 40 : (fam === '4g' ? 18 : 4); if (fam === 'wifi') why.push('sends photos to your phone over WiFi, no SIM'); }
      if (answers.photos === 'far') { s += fam === '4g' ? 45 : 0; if (fam === '4g') why.push('sends photos to your phone over 4G, wherever you are'); }
      /* Where will it go? */
      if (answers.place === 'garden') { s += p.price < 120 ? 10 : 4; }
      if (answers.place === 'remote') { s += fam === '4g' ? 14 : 0; s += p.battery >= 15 ? 6 : 0; }
      if (answers.place === 'security') { s += fam === '4g' ? 10 : (fam === 'wifi' ? 6 : 0); s += p.trigger && p.trigger <= 0.25 ? 6 : 0; }
      if (answers.place === 'woods') { s += p.weather === 'IP67' ? 6 : 0; s += p.battery >= 15 ? 6 : 0; }
      /* What matters most? */
      if (answers.want === 'simple') { s += Math.max(0, 20 - p.price / 12); if (p.price < 100) why.push('our simplest, lowest-priced option'); }
      if (answers.want === 'night') { s += (p.night || 0) / 2; if (p.night >= 30) why.push('no-glow night vision up to ' + p.night + ' m'); }
      if (answers.want === 'video') { s += p.k4 ? 18 : 0; if (p.k4) why.push('records 4K video'); }
      if (answers.want === 'fast') { s += p.trigger ? (0.9 - p.trigger) * 30 : 0; if (p.trigger && p.trigger <= 0.2) why.push(p.trigger + ' s trigger'); }
      if (answers.want === 'ai') { s += p.ai ? 30 : 0; if (p.ai) why.push('AI that recognises 40+ species'); }
      return { p: p, s: s, why: why };
    }
    function render() {
      var ranked = data.map(score).sort(function (a, b) { return b.s - a.s; });
      var best = ranked[0], alts = ranked.slice(1, 3);
      var esc = function (t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var box = $('[data-x-finder-out]', modal);
      if (!best) { box.innerHTML = '<p>Have a look at the full range.</p>'; return; }
      var why = best.why.length ? best.why.slice(0, 3).join(', ') : best.p.tagline;
      box.innerHTML =
        '<div class="x-res"><img src="' + esc(best.p.img) + '" alt="" width="110" height="110">' +
        '<div><div class="x-res__match">Best match for you</div><div class="x-res__name">' + esc(best.p.title) + '</div>' +
        '<p class="x-res__why">' + esc(why.charAt(0).toUpperCase() + why.slice(1)) + '.</p>' +
        '<a class="x-btn x-btn--sm" href="' + esc(best.p.url) + '">See it · ' + esc(best.p.priceText) + '<span class="x-btn__chip"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8h10M9 4l4 4-4 4"/></svg></span></a></div></div>' +
        alts.map(function (a) {
          return '<a class="x-res x-res--alt" href="' + esc(a.p.url) + '" style="text-decoration:none;color:inherit"><img src="' + esc(a.p.img) + '" alt="" width="64" height="64"><div><div class="x-res__match">Also worth a look</div><div class="x-res__name">' + esc(a.p.title) + '</div></div><b style="font-family:var(--x-display);letter-spacing:-.02em">' + esc(a.p.priceText) + '</b></a>';
        }).join('');
    }

    /* Floating pill */
    var fab = $('[data-x-fab]');
    if (fab) {
      var onS = function () { fab.classList.toggle('is-shown', w.scrollY > 700 && (w.innerHeight + w.scrollY) < d.body.scrollHeight - 400); };
      w.addEventListener('scroll', onS, { passive: true }); onS();
    }
  }


  /* ---------- Site-wide motion layer (round 18): text, images and cards reveal as you scroll ---------- */
  function words(el) {
    if (el.dataset.xWords) return; el.dataset.xWords = '1';
    var n = 0;
    var walk = function (node) {
      [].slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var parts = c.textContent.split(/(\s+)/), frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
            var o = d.createElement('span'); o.className = 'x-w'; var i = d.createElement('span'); i.style.setProperty('--wi', n++); i.textContent = p; o.appendChild(i); frag.appendChild(o);
          });
          c.parentNode.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'BR' && c.tagName !== 'SVG') { walk(c); }
      });
    };
    walk(el);
  }
  function auto(root) {
    if (reduce || !('IntersectionObserver' in w)) return;
    var skip = '.x-sec, .x-dusk, .x-hero, .x-band, header, .header-section, footer, cart-drawer, .product-section, .wc-hero, [data-x-foot], .marquee-section, .announcement-bar, .x-finder, dialog';
    var sections = root === d ? $$('.shopify-section') : [root];
    var vh = w.innerHeight, list = [];
    var ok = function (el) { return el && !el.__xAuto && !el.closest(skip) && !(el.parentElement && el.parentElement.closest('.x-a-card, .x-a-up')) && el.getBoundingClientRect().top > vh * 0.92; };
    var tag = function (el, cls, i) { if (!ok(el)) return; el.__xAuto = 1; el.classList.add(cls); if (i != null) el.style.setProperty('--ai', i); list.push(el); };
    sections.forEach(function (sec) {
      if (sec.matches && sec.matches(skip)) return;
      [ '.product-card', '.article-card', '.wc-ccard', '.wc-job-card', '.wc-tile', '.wc-col-card', '.wc-feature', '.wc-howto-step', 'accordion-row, details', '.wc-cmp-card', '.splide__slide > *' ].forEach(function (sel) {
        $$(sel, sec).forEach(function (c, i) { tag(c, 'x-a-card', i % 6); });
      });
      $$('h1, h2, .h1, .h2', sec).forEach(function (h) {
        if (!ok(h) || h.textContent.trim().length > 90) return;
        words(h); tag(h, 'x-a-words');
      });
      $$('h6, .h6, .text-block p, .rte p, .text-block li', sec).forEach(function (p, i) { tag(p, 'x-a-up', i % 4); });
      $$('.button', sec).forEach(function (bt) { tag(bt, 'x-a-up', 2); });
      $$('img', sec).forEach(function (im) { if (im.closest('.wc-bundles, .rating-stars, .payment-methods') || im.getBoundingClientRect().width < 160) return; tag(im, 'x-a-img'); });
    });
    if (!list.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target; t.classList.add('is-in'); io.unobserve(t);
        if (!t.classList.contains('x-a-words')) setTimeout(function () { t.classList.remove('x-a-up', 'x-a-card', 'x-a-img', 'is-in'); t.style.removeProperty('--ai'); }, 1700);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    list.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Scroll progress line + magnetic primary buttons ---------- */
  function chrome() {
    if (reduce || w.__xChrome) return; w.__xChrome = 1;
    if (!w.matchMedia('(hover: hover)').matches) return;
    d.addEventListener('pointermove', function (e) {
      var b = e.target.closest && e.target.closest('.button--primary, .x-btn');
      if (!b || b.closest('.wc-bundles, cart-drawer, form[action*="/cart"]')) return;
      var r = b.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      b.style.translate = (x * 6).toFixed(1) + 'px ' + (y * 4).toFixed(1) + 'px';
      if (!b.__xMag) { b.__xMag = 1; b.addEventListener('pointerleave', function () { b.style.translate = ''; }); }
    });
  }

  function init(root) { reveal(root); hero(root); rail(root); spot(root); dusk(root); parallax(root); finder(); try { auto(root); if (root === d) chrome(); } catch (e) {} }
  w.__wcx = 1;
  d.documentElement.classList.add('x-js');
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
